import React, { useState } from "react";
import * as Components from "../../../components/all";

import Chart from "react-apexcharts";
import { useNavigate } from "react-router-dom";

import { AiFillEye } from "react-icons/ai";
import { MdLocalOffer } from "react-icons/md";

export default function Packages() {
    const navigate = useNavigate();
    // eslint-disable-next-line no-unused-vars
    const [loading, setLoading] = useState(false);

    // Packages Data
    var packagesData = {
        totalPackages: 69908,
        packagesTrend: [
            { city: "Package 1", users: 400 },
            { city: "Package 2", users: 30 },
            { city: "Package 3", users: 10 },
            { city: "Package 4", users: 200 },
            { city: "Package 5", users: 100 },
        ],
        allPackages: [
            {
                id: 1,
                name: "Package 1",
            },
            {
                id: 2,
                name: "Package 2",
            },
            {
                id: 3,
                name: "Package 3",
            },
            {
                id: 4,
                name: "Package 4",
            },
            {
                id: 5,
                name: "Package 5",
            },
        ],
    };

    // Search Feature
    const [filteredUsers, setFilteredUsers] = useState(packagesData.allPackages);
    const search = (term) => {
        if (term === "") {
            setFilteredUsers(packagesData.allPackages);
            return;
        }

        const filtered = packagesData.allPackages.filter(
            (x) =>
                x.name.toLowerCase()
                    .indexOf(term.toLowerCase()) > -1
        );
        setFilteredUsers(filtered);
    };

    // Settings
    var settings = {
        cityUsersGraph: {
            options: {
                chart: {
                    type: "donut",
                    stacked: false,
                },
                labels: packagesData.packagesTrend.map((x) => x.city),
                legend: {
                    position: "bottom",
                    horizontalAlign: "center",
                },
            },
            series: packagesData.packagesTrend.map((x) => x.users),
        },
    };

    return loading === true ? (
        <Components.Loader />
    ) : (
        <div
            className="Packages
            overflow-x-hidden overflow-y-auto 
            h-full 
            w-full
            sm:p-3 md:p-5
            flex flex-row flex-wrap
            "
        >
            {/* LEFT CARDS ROW */}
            <div
                className="LEFT-CARDS 
				flex flex-col
				sm:flex-[1.1]
				sm:min-w-[420px] 
				max-sm:w-full
				"
            >
                {/* left top cards */}
                <div className="LEFT-TOP-CARDS flex flex-col sm:flex-row sm:items-stretch sm:justify-between sm:flex-wrap flex-[1]">
                    {/* card 1 */}
                    <div
                        style={{
                            boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
                        }}
                        className="
						min-h-[120px] 
						sm:min-w-[450px] flex-1 
						rounded-md
						p-5 m-2
						bg-white 
						flex flex-col
						"
                    >
                        {/* heading */}
                        <div className="flex items-center">
                            <div
                                className="
                            h-6 w-6 
                            flex items-center justify-center
                            rounded-full
                            bg-bg1 
                            text-main
                            "
                            >
                                <MdLocalOffer />
                            </div>

                            <h1 className="ml-2 text-darker">Total Packages</h1>


                            <button
                                className="bg-main text-white 
                            px-4 py-1 ml-auto 
                            text-sm rounded-md 
                            font-medium 
                            max-sm:w-[150px]
                            max-sm:mt-auto
                            duration-300 ease-in-out
                            hover:opacity-70
                            "
                                onClick={() => navigate("newps")}
                            >
                                + Create New Package
                            </button>
                        </div>

                        {/* data */}
                        <div className="flex items-center justify-between mt-auto">
                            <h1 className="text-3xl font-medium tracking-tighter">
                                {packagesData.totalPackages.toLocaleString()}
                            </h1>

                        </div>
                    </div>
                </div>

                {/* left bottom cards */}
                <div className="LEFT-BOTTOM-CARDS flex flex-col sm:flex-row sm:items-stretch sm:justify-between sm:flex-wrap flex-[5]">
                    {/* card 1 */}
                    <div
                        style={{
                            boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
                        }}
                        className="
						min-h-[400px] sm:min-h-[520px] 
						sm:min-w-[400px] 
						flex-1 
						max-sm:max-w-full 
						p-5 m-2
						rounded-md
						bg-white 
						flex flex-col
						overflow-hidden
						"
                    >
                        {/* heading */}
                        <div className="p-2 pt-0 w-full">
                            <div className="flex items-center justify-between">
                                <h1 className="text-xl">Packages</h1>
                            </div>
                            <p className="text-dark text-sm">Best selling packages</p>
                        </div>

                        {/* data */}
                        <div className="w-full flex-1 overflow-hidden">
                            <Chart
                                options={settings.cityUsersGraph.options}
                                series={settings.cityUsersGraph.series}
                                type="donut"
                                height="100%"
                                width="100%"
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* RIGHT CARDS ROW */}
            <div
                className="RIGHT-CARDS 
				flex flex-col 
			    sm:flex-1
				overflow-hidden
				sm:min-w-[500px] 
				max-sm:w-full
			"
            >
                {/* card 1 */}
                <div
                    style={{
                        boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
                    }}
                    className="
                    min-h-[380px] sm:min-h-[480px] h-full 
                    p-5 m-2
                    rounded-md
                    bg-white 
                    flex flex-col
                    overflow-auto
                    "
                >
                    {/* heading */}
                    <div className="p-2 py-0 w-full">
                        <div className="flex items-center justify-between">
                            <h1 className="text-xl">Search Packages</h1>
                        </div>
                    </div>

                    {/* search */}
                    <div
                        className={`
						mb-4 mt-2 p-1 bg-gray-50 rounded flex
						`}
                    >
                        <div className="relative flex-1">
                            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                <svg
                                    className="w-5 h-5 text-gray-500"
                                    aria-hidden="true"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                        clipRule="evenodd"
                                    ></path>
                                </svg>
                            </div>
                            <input
                                type="text"
                                className="w-full block p-1.5 pl-10 text-sm text-gray-900  border-gray-300 rounded bg-gray-50 focus:outline-none"
                                placeholder="Search for packages"
                                onChange={(e) => search(e.target.value)}
                            />
                        </div>
                    </div>

                    {/* data */}
                    <div className="max-h-[calc(100vh)] 2xl:max-h-[calc(100vh-220px)] flex-1 overflow-y-auto">
                        {/* table */}
                        <div className="h-fit w-full overflow-y-hidden overflow-x-auto shadow-md sm:rounded">
                            <div className="overflow-hidden min-w-max">
                                <table className="w-full text-sm text-left text-gray-500">
                                    {/* head */}
                                    <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                                        <tr>
                                            <th scope="col" className="px-6 py-3">
                                                Name
                                            </th>
                                            <th scope="col" className="px-3 py-3">
                                                Details
                                            </th>
                                        </tr>
                                    </thead>

                                    {/* body */}
                                    <tbody className="">
                                        {filteredUsers
                                            .map(({ id, name, city }, index) => (
                                                <tr
                                                    key={index}
                                                    className="bg-white border-b hover:bg-gray-50"
                                                >
                                                    <th
                                                        scope="row"
                                                        className="px-6 py-4 font-medium text-darker whitespace-nowrap"
                                                    >
                                                        {name}
                                                    </th>

                                                    <td className="py-4">
                                                        <p
                                                            className="text-blue-400 hover:underline flex items-center w-fit
														cursor-pointer
														pl-6
														"
                                                            onClick={() => navigate(`/packages/package/${id}`)}
                                                        >
                                                            <AiFillEye size={20} />
                                                        </p>
                                                    </td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
